export default "__VITE_ASSET__FWWCe2zP__"